import { render, staticRenderFns } from "./WeightPlantNew.vue?vue&type=template&id=f407d106"
import script from "./WeightPlantNew.vue?vue&type=script&lang=js"
export * from "./WeightPlantNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports